import { ConfigService, SystemUrlService } from "@xo/client-common";

export class Type6DateUrlService extends SystemUrlService {
    constructor(system: string, configService: ConfigService) {
        super(system, "SpecApp", "Type6Date", configService);
    }
}
